import React, {useState, useEffect} from 'react';
import Loader from "react-loader-spinner";
import * as typingCenterUserActions from '../../Redux/Actions/typingCenterUser';
import {toastMessage} from '../../utils/toast';
import { getParams } from '../../utils';
import { useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { clearSession } from '../../utils/initiate';

const UserInfo = ({ history }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    let params = getParams(window.location.search);
    let userID = params.userID;

    useEffect(() => {
        setLoading(true);
        typingCenterUserActions.getIndividual(userID).then(res => {
            if(res && res.data){
                setData(res.data);
            }else{
                toastMessage('error', (res && res.message) || `Unable to get the user info`);
            }
            setLoading(false);
        }).catch(err => {
            (err.response.status === 401) && clearSession(dispatch, history);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userID]);
    
    return(
        <div className="container-fluid">
            <div className="my-4">
                <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push(`/users`)}>{t("userManagement.userInfo.users")}</span>
                <span className="card-label font-weight-bolder mx-2">/</span>
                <span className="card-label font-weight-bolder text-dark">{data.name}</span>
            </div>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card card-stretch">
                        <div className="card-header border-0 py-2">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder text-dark">{t("userManagement.userInfo.title")}</span>
                            </h3>
                        </div>
                        {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center'}} />
                        : <div className="card-body py-0">
                            <div className="form-group mt-2">
                                <label className="mb-1">{t("userManagement.userInfo.userID")}</label>
                                <input type="text" name="userID" value={data.id} readOnly className="form-control" />
                            </div>
                            <div className="form-group mt-2">
                                <label className="mb-1">{t("userManagement.userInfo.name")}</label>
                                <input type="text" name="Name" value={data.name} readOnly className="form-control" />
                            </div>
                            <div className="form-group mt-2">
                                <label className="mb-1">{t("userManagement.userInfo.email")}</label>
                                <input type="text" name="Email" value={data.email} readOnly className="form-control" />
                            </div>
                            <div className="form-group mt-2">
                                <label className="mb-1">{t("userManagement.userInfo.mobileNumber")}</label>
                                <input type="text" name="Mobile Number" value={data.mobileNumber} readOnly className="form-control" />
                            </div>
                            <div className="form-group mt-2">
                                <label className="mb-1">{t("userManagement.addUser.emiratesId")}</label>
                                <input type="text" name="Mobile Number" value={data.emiratesId} readOnly className="form-control" />
                            </div>
                            <div className="form-group mt-2">
                                <label className="mb-1">{t("userManagement.userInfo.extensionNumber")}</label>
                                <input type="text" name="Extension Number" value={data.extensionNumber} readOnly className="form-control" />
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserInfo;